/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicTagDiscovery extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicTagDiscovery");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicTagDiscovery.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicTagDiscovery>): BackgroundJobPayloadForPeriodicTagDiscovery {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicTagDiscovery(), model);
        BackgroundJobPayloadForPeriodicTagDiscovery.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicTagDiscovery>): BackgroundJobPayloadForPeriodicTagDiscovery {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicTagDiscovery.newInstance(<BackgroundJobPayloadForPeriodicTagDiscovery> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicTagDiscovery) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicTagDiscovery.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicTagDiscovery): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicTagDiscovery.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
